import { render, staticRenderFns } from "./customerTabs.vue?vue&type=template&id=7a84b8d5&scoped=true&"
import script from "./customerTabs.vue?vue&type=script&lang=js&"
export * from "./customerTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84b8d5",
  null
  
)

export default component.exports